'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _colors = require('HubStyleTokens/colors');

var colors = _interopRequireWildcard(_colors);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ICON_COLOR_MAP = {
  danger: colors.ALERT_DANGER,
  primary: colors.LORAX,
  secondary: colors.LORAX,
  tertiary: colors.HEFFALUMP,
  success: colors.OZ,
  link: colors.CALYPSO
};

var ICON_SIZE_MAP = {
  large: 32,
  small: 16,
  'extra-small': 10,
  default: 24,
  huge: 48
};

var SPINNER_SIZE_MAP = {
  large: 52,
  small: 28,
  'extra-small': 20,
  default: 40,
  huge: 64
};

var USE_CLASSES = {
  danger: 'private-spinner--destructive',
  primary: 'private-spinner--primary',
  'primary-white': 'private-spinner--primary-white',
  secondary: 'private-spinner--secondary',
  'secondary-ghost': 'private-spinner--secondary-ghost',
  tertiary: 'private-spinner--tertiary',
  success: 'private-spinner--success',
  'tertiary-light': 'private-spinner--tertiary', // same as tertiary
  link: 'private-spinner--link'
};

var SIZE_CLASSES = {
  default: 'private-spinner--default',
  large: 'private-spinner--lg',
  huge: 'private-spinner--huge',
  small: 'private-spinner--sm',
  'extra-small': 'private-spinner--xs'
};

exports.default = _react2.default.createClass({
  displayName: 'UISpinner',

  propTypes: {
    failed: _react.PropTypes.bool,
    showResult: _react.PropTypes.bool,
    className: _react.PropTypes.string,
    resultAnimationDuration: _react.PropTypes.number.isRequired,
    resultIcon: _react.PropTypes.string,
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)),
    size: _react.PropTypes.oneOf(Object.keys(SIZE_CLASSES)),
    onResultDisplayFinish: _react.PropTypes.func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      failed: false,
      showResult: false,
      resultAnimationDuration: 1500,
      resultIcon: 'check',
      onResultDisplayFinish: _reactUtils.emptyFunction,
      use: 'secondary',
      size: 'default'
    };
  },
  getInitialState: function getInitialState() {
    var showResult = this.props.showResult;


    return {
      displayResult: showResult
    };
  },
  componentDidMount: function componentDidMount() {
    var showResult = this.props.showResult;

    if (showResult) {
      this.setResultDisplayTimeout();
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var showResult = nextProps.showResult;


    if (this.state.displayResult !== showResult) {
      this.setState({
        displayResult: showResult
      });
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    if (!prevState.displayResult && this.state.displayResult) {
      this.setResultDisplayTimeout();
    } else if (prevState.displayResult && !this.state.displayResult) {
      clearTimeout(this.resultDisplayTimeout);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    clearTimeout(this.resultDisplayTimeout);
  },
  setResultDisplayTimeout: function setResultDisplayTimeout() {
    var resultAnimationDuration = this.props.resultAnimationDuration;

    clearTimeout(this.resultDisplayTimeout);
    this.resultDisplayTimeout = setTimeout(this.handleDisplayResultFinish, resultAnimationDuration);
  },
  handleDisplayResultFinish: function handleDisplayResultFinish() {
    var onResultDisplayFinish = this.props.onResultDisplayFinish;

    onResultDisplayFinish();
  },
  getClassName: function getClassName() {
    var _props = this.props,
        className = _props.className,
        use = _props.use,
        size = _props.size;
    var displayResult = this.state.displayResult;


    return (0, _reactUtils.classNames)('private-spinner', className, USE_CLASSES[use], SIZE_CLASSES[size], {
      'private-spinner--showing-result': displayResult
    });
  },
  getIconSize: function getIconSize(_ref) {
    var size = _ref.size;

    return ICON_SIZE_MAP[size];
  },
  getIconColor: function getIconColor(_ref2) {
    var use = _ref2.use;

    return ICON_COLOR_MAP[use];
  },
  renderIcon: function renderIcon(_ref3) {
    var failed = _ref3.failed,
        resultIcon = _ref3.resultIcon,
        size = _ref3.size,
        use = _ref3.use;

    if (failed || !resultIcon) {
      return null;
    }

    return _react2.default.createElement(
      'div',
      { className: 'private-spinner__result' },
      _react2.default.createElement(_UIIcon2.default, {
        className: 'private-spinner__result-icon',
        name: resultIcon,
        color: this.getIconColor({ use: use }),
        size: this.getIconSize({ size: size })
      })
    );
  },
  render: function render() {
    var _props2 = this.props,
        failed = _props2.failed,
        __showResult = _props2.showResult,
        __className = _props2.className,
        __resultAnimationDuration = _props2.resultAnimationDuration,
        resultIcon = _props2.resultIcon,
        use = _props2.use,
        size = _props2.size,
        __onResultDisplayFinish = _props2.onResultDisplayFinish,
        rest = _objectWithoutProperties(_props2, ['failed', 'showResult', 'className', 'resultAnimationDuration', 'resultIcon', 'use', 'size', 'onResultDisplayFinish']);

    var height = SPINNER_SIZE_MAP[size];

    return _react2.default.createElement(
      'div',
      _extends({}, rest, { className: this.getClassName() }),
      _react2.default.createElement(
        'div',
        { className: 'private-spinner-wrapper' },
        _react2.default.createElement(
          'svg',
          {
            height: height,
            width: height,
            className: 'private-spinner__ring',
            viewBox: '0 0 50 50'
          },
          _react2.default.createElement('circle', {
            className: 'private-spinner__ring-background',
            cx: '25',
            cy: '25',
            r: '22.5',
            fill: 'none',
            strokeWidth: '5'
          }),
          _react2.default.createElement('circle', {
            className: 'private-spinner__ring-path',
            cx: '25',
            cy: '25',
            r: '22.5',
            fill: 'none',
            strokeWidth: '5'
          })
        )
      ),
      this.renderIcon({ failed: failed, resultIcon: resultIcon, size: size, use: use })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/loading/UISpinner.js
// module id = 310
// module chunks = 0